import { render, staticRenderFns } from "./CommentsInput.vue?vue&type=template&id=06232e1e"
import script from "./CommentsInput.vue?vue&type=script&lang=js"
export * from "./CommentsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports